(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-group-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var root = document.querySelector('[data-kw-group-reviews]');
  if (!root) return;

  var GROUPED = root.dataset.grouped === 'true';
  var THIS_URL = (root.dataset.thisUrl || '').replace(/[?#].*$/, '');
  var AVG = root.dataset.ratingAvg || '';
  var COUNT = root.dataset.ratingCount || '';
  var WANT_BADGE_AVG = root.dataset.showAverageInBadge === 'true';
  var PRE = root.dataset.attributionLabel || 'on';
  var THIS_LABEL = root.dataset.thisLabel || 'This colourway';

  var scopeTpl = root.querySelector('[data-kwgr-scope]');
  var chipsTpl = root.querySelector('[data-kwgr-chips]');

  /* Judge.me renders asynchronously and re-renders the list on
     sort / search / paginate, so everything here is idempotent and
     re-runnable. */
  function widget() {
    return document.querySelector('.jdgm-rev-widg');
  }

  function searchInput() {
    return document.querySelector('.jdgm-rev-widg input.jdgm-review-search');
  }

  /* ── 1. scope line + chips into Judge.me's header ────────── */
  function mountHeader() {
    var w = widget();
    if (!w) return false;
    var header = w.querySelector('.jdgm-rev-widg__header');
    if (!header) return false;

    /* Both go in as direct children of the header. Judge.me rebuilds its
       own rows during hydration and reparents anything nested inside
       them, so anchoring to siblings is the only stable placement — and
       re-inserting when they go missing makes this self-healing. */
    if (scopeTpl && !header.querySelector('.kwgr-scope')) {
      var stars = header.querySelector('.jdgm-row-stars');
      header.insertBefore(
        scopeTpl.content.cloneNode(true),
        stars ? stars.nextSibling : header.querySelector('.jdgm-row-search')
      );
    }

    if (chipsTpl && !header.querySelector('.kwgr-chips')) {
      header.insertBefore(
        chipsTpl.content.cloneNode(true),
        header.querySelector('.jdgm-row-search')
      );
      bindChips(header);
    }

    return true;
  }

  /* ── 2. chips drive Judge.me's own search ────────────────
     Verified contract: the widget refetches from
     api.judge.me/reviews/reviews_for_widget with &search=<term>,
     still filtered to product_id — i.e. still the group. */
  function runSearch(term) {
    var input = searchInput();
    if (!input) return;
    var setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;
    setter.call(input, term);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(
      new KeyboardEvent('keyup', {
        bubbles: true,
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        which: 13
      })
    );
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindChips(header) {
    var chips = header.querySelectorAll('.kwgr-chip');
    Array.prototype.forEach.call(chips, function (chip) {
      chip.setAttribute('aria-pressed', 'false');
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') === 'true';
        Array.prototype.forEach.call(chips, function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        if (on) {
          runSearch('');
        } else {
          chip.setAttribute('aria-pressed', 'true');
          runSearch(chip.dataset.kwgrTerm || '');
        }
      });
    });

    /* Typing in the box directly clears any active chip. */
    var input = searchInput();
    if (input && !input.dataset.kwgrBound) {
      input.dataset.kwgrBound = '1';
      input.addEventListener('input', function () {
        var val = input.value.trim().toLowerCase();
        Array.prototype.forEach.call(chips, function (c) {
          c.setAttribute(
            'aria-pressed',
            String((c.dataset.kwgrTerm || '').toLowerCase() === val && val !== '')
          );
        });
      });
    }
  }

  /* ── 3. per-review product attribution ───────────────────
     Judge.me already emits data-product-title / data-product-url on
     every review and leaves an empty .jdgm-row-product to hold the
     visible line. It only fills that slot when
     show_product_url_for_grouped_product is ON. We fill it when it is
     empty, and stand down entirely if Judge.me starts filling it. */
  function mountAttribution() {
    if (!GROUPED) return;
    var revs = document.querySelectorAll('.jdgm-rev-widg .jdgm-rev');
    Array.prototype.forEach.call(revs, function (rev) {
      var header = rev.querySelector('.jdgm-rev__header');
      if (!header) return;

      /* Judge.me adds its own (empty) slot during hydration, which can
         land after we have already created a stand-in. Once the real one
         shows up, drop ours so the review never carries two. */
      var ours = rev.querySelectorAll('.jdgm-row-product[data-kwgr-slot]');
      if (ours.length && rev.querySelector('.jdgm-row-product:not([data-kwgr-slot])')) {
        Array.prototype.forEach.call(ours, function (s) {
          s.parentNode.removeChild(s);
        });
      }

      var slot = rev.querySelector('.jdgm-row-product');
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'jdgm-row-product';
        slot.setAttribute('data-kwgr-slot', '');
        header.insertBefore(slot, header.firstChild);
      }

      /* Already ours, or Judge.me is now rendering its own line. */
      if (slot.querySelector('.kwgr-attr')) return;
      if (slot.textContent.trim() || slot.children.length) return;

      var title = rev.getAttribute('data-product-title') || '';
      var url = (rev.getAttribute('data-product-url') || '').replace(/[?#].*$/, '');
      if (!title) return;

      var el;
      if (url && url === THIS_URL) {
        el = document.createElement('span');
        el.className = 'kwgr-attr kwgr-attr--this';
        el.innerHTML = '<span class="kwgr-attr__name"></span>';
        el.querySelector('.kwgr-attr__name').textContent = THIS_LABEL;
      } else {
        el = document.createElement(url ? 'a' : 'span');
        el.className = 'kwgr-attr';
        if (url) el.setAttribute('href', url);
        el.innerHTML =
          '<span class="kwgr-attr__pre"></span> <span class="kwgr-attr__name"></span>';
        el.querySelector('.kwgr-attr__pre').textContent = PRE;
        el.querySelector('.kwgr-attr__name').textContent = title;
      }
      slot.appendChild(el);
    });
  }

  /* ── 4. average alongside the buy-box star badge ─────────
     Judge.me's preview badge renders stars + "N reviews" but never the
     numeral. Prepending it is the only edit made to that block.

     No one-shot flag here: Judge.me hydrates the badge late and rewrites
     the text node, so this has to be re-appliable. The "already starts
     with the average" check is what stops it looping. */
  function mountBadgeAverage() {
    if (!WANT_BADGE_AVG || !AVG) return;
    var texts = document.querySelectorAll('.jdgm-prev-badge__text');
    Array.prototype.forEach.call(texts, function (t) {
      var raw = t.textContent.trim();
      if (!raw || raw.indexOf(AVG) === 0) return;
      t.textContent = AVG + ' · ' + raw;
    });
  }

  /* The badge lives in the buy box, outside the review widget, so it
     needs its own observer to catch that late rewrite. */
  function observeBadges() {
    var badges = document.querySelectorAll('.jdgm-widget.jdgm-preview-badge');
    Array.prototype.forEach.call(badges, function (b) {
      if (b.kwgrObserved) return;
      b.kwgrObserved = true;
      new MutationObserver(schedule).observe(b, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function render() {
    mountHeader();
    mountAttribution();
    observeBadges();
    mountBadgeAverage();
  }

  /* Judge.me boots late and swaps the list out from under us.
     Observe, debounce, and let render() no-op when there is nothing
     left to do — the guards above make it self-terminating. */
  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      render();
    }, 60);
  }

  function start() {
    render();
    var target = document.querySelector('.jdgm-review-widget') || document.body;
    new MutationObserver(schedule).observe(target, {
      childList: true,
      subtree: true
    });
    /* Belt and braces for a slow Judge.me boot — runs the full ~10s
       whether or not the widget has appeared, because the buy-box badge
       and the widget hydrate independently. */
    var tries = 0;
    var poll = window.setInterval(function () {
      tries += 1;
      render();
      if (tries > 40) window.clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kw-review-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var root = document.querySelector('[data-kw-review-tabs]');
  if (!root) return;

  var mySection = root.closest('.shopify-section');
  var bar = root.querySelector('[data-kwrt-bar]');
  var tabs = root.querySelectorAll('[data-kwrt-tab]');
  var counts = {
    product: root.querySelector('[data-kwrt-count="product"]'),
    store: root.querySelector('[data-kwrt-count="store"]')
  };

  var LAZY_STORE = root.dataset.lazyStore === 'true';
  var found = { product: null, store: null };
  var active = root.dataset.defaultTab === 'store' ? 'store' : 'product';
  var storeEverShown = false;

  /* The store widget reuses the review widget's internals, so a bare
     .jdgm-rev-widg match can land inside it. Always resolve the store widget
     first and treat anything inside it as off-limits. */
  var STORE_SEL =
    '.jdgm-all-reviews-widget, [data-widget="all-reviews-v2025"], [data-widget-name="all_reviews_page"], [data-widget-name="jdgm-all-reviews-widget-v2025"]';
  var PRODUCT_SEL =
    '.jdgm-review-widget, [data-widget-name="review_widget"], [data-widget="review-widget-v2025"], .jdgm-rev-widg';

  function sectionOf(el) {
    var sec = el.closest ? el.closest('.shopify-section') : null;
    if (!sec || sec === mySection) return null;
    return sec;
  }

  function findStoreSection() {
    var el = document.querySelector(STORE_SEL);
    return el ? sectionOf(el) : null;
  }

  function findProductSection() {
    var candidates = document.querySelectorAll(PRODUCT_SEL);
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.closest(STORE_SEL)) continue;
      if (el.closest('.jdgm-preview-badge')) continue;
      var sec = sectionOf(el);
      if (sec) return sec;
    }
    return null;
  }

  /* Tag each app section in place. Nothing is moved — see the header comment.
     Runs until both are found; Judge.me boots late, so a widget missing on the
     first pass is not missing for good. */
  function claim(key, sec) {
    if (!sec || found[key]) return;
    found[key] = sec;
    sec.classList.add('kwrt-panel', 'kwrt-panel--' + key);
    sec.setAttribute('role', 'tabpanel');
    sec.setAttribute('aria-labelledby', 'kwrt-tab-' + key);
    var btn = root.querySelector('[data-kwrt-tab="' + key + '"]');
    if (btn && sec.id) btn.setAttribute('aria-controls', sec.id);
  }

  function bind() {
    claim('store', findStoreSection());
    claim('product', findProductSection());
    reflect();
  }

  /* The bar is only honest when there are two things to switch between.
     With one widget, show it and stay out of the way. */
  function reflect() {
    var both = !!found.product && !!found.store;
    bar.hidden = !both;

    if (both) {
      setActive(active, true);
      return;
    }
    if (found.product) found.product.hidden = false;
    if (found.store) found.store.hidden = false;
  }

  function setActive(key, silent) {
    active = key;
    Array.prototype.forEach.call(tabs, function (t) {
      var on = t.dataset.kwrtTab === key;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
    });
    if (found.product) found.product.hidden = key !== 'product';
    if (found.store) found.store.hidden = key !== 'store';

    if (key === 'store' && !storeEverShown) {
      storeEverShown = true;
      nudge();
      holdProductSubtab();
    }
    if (!silent) readStoreCount();
  }

  /* A widget hidden on load may never have crossed an IntersectionObserver, so
     Judge.me can still be waiting to hydrate the first time the tab is opened. */
  function nudge() {
    try {
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
    } catch (e) {}
    if (typeof window.jdgmSetupWidgets === 'function') {
      try {
        window.jdgmSetupWidgets();
      } catch (e) {}
    }
  }

  /* Liquid has the grouped product count (reviews.rating_count) but no
     store-wide total, so the store tab's number is read off the widget once it
     has rendered. No number is better than a wrong one. */
  function readStoreCount() {
    if (!found.store || !counts.store || counts.store.textContent.trim()) return;
    var txt = found.store.innerText || '';
    var m = txt.match(/Based on\s+([\d,]+)\s+review/i);
    if (m) {
      counts.store.textContent = m[1];
      return;
    }
    var sub = found.store.querySelector('.jdgm-subtab__count');
    if (sub && sub.textContent.trim()) counts.store.textContent = sub.textContent.trim();
  }

  /* The sub-tab bar is hidden in CSS, so whichever sub-tab is active is the one
     the shopper is stuck with. show_first: "product" already makes that the
     product list, but the widget re-renders on sort and paginate, so this
     re-asserts it rather than trusting a setting we have already seen the
     widget ignore. Clicking only when shop is active keeps it idempotent. */
  function holdProductSubtab() {
    if (!found.store) return;
    var names = found.store.querySelectorAll('.jdgm-subtab__name');
    if (names.length < 2) return;
    var activeIsShop = false;
    var productTab = null;
    Array.prototype.forEach.call(names, function (n) {
      var isShop = /shop/i.test(n.textContent);
      if (!isShop) productTab = n;
      if (isShop && n.classList.contains('jdgm--active')) activeIsShop = true;
    });
    if (activeIsShop && productTab) productTab.click();
  }

  Array.prototype.forEach.call(tabs, function (t) {
    t.addEventListener('click', function () {
      setActive(t.dataset.kwrtTab);
    });
    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var next = active === 'product' ? 'store' : 'product';
      setActive(next);
      root.querySelector('[data-kwrt-tab="' + next + '"]').focus();
    });
  });

  /* Judge.me's preview badge under the title scrolls to the review widget, so
     make sure that widget is the visible one before the browser scrolls. */
  document.addEventListener(
    'click',
    function (e) {
      var badge = e.target.closest && e.target.closest('.jdgm-preview-badge');
      if (badge && found.product) setActive('product');
    },
    true
  );

  /* Theme editor: selecting a hidden section in the sidebar would otherwise
     scroll to nothing. Open the tab that owns it instead. */
  document.addEventListener('shopify:section:select', function (e) {
    if (found.store && e.target === found.store) setActive('store');
    else if (found.product && e.target === found.product) setActive('product');
  });
  document.addEventListener('shopify:section:load', function () {
    found.product = null;
    found.store = null;
    bind();
  });

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      bind();
      readStoreCount();
      holdProductSubtab();
    }, 60);
  }

  function start() {
    bind();
    if (!LAZY_STORE && found.store) {
      nudge();
      storeEverShown = true;
    }
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
    var tries = 0;
    var poll = window.setInterval(function () {
      tries += 1;
      bind();
      readStoreCount();
      holdProductSubtab();
      if (tries > 40) window.clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
